import md5 from 'md5';
import { unpack, pack } from '../../lib/jsonc';

class CacheModel {
	constructor() {
		this.cache = new Map();
		this.load();

		window.addEventListener('blur', () => this.save());
		window.addEventListener('focus', () => this.load());
	}

	clear() {
		this.cache.clear();
		window.localStorage.removeItem('cache');
	}

	delete(id) {
		this.cache.forEach(v => {
			if (v.id === id) {
				this.cache.delete(v);
			}
		});
	}

	flag(id) {
		this.cache.forEach(v => {
			if (v.id === id) {
				return v.flag && v.time * 1000 > new Date().getTime();
			}
		});
		return false;
	}

	get(key) {
		return this.cache.get(md5(key));
	}

	getById(id) {
		this.cache.forEach(v => {
			if (v.id === id) {
				return v.response;
			}
		});
		return null;
	}

	// a condition qu'il n'y ai qu'un resultat pour la clef de cache
	in(key) {
		return this.cache.has(md5(key));
	}

	load() {
		try {
			const cache = localStorage.getItem('cache');
			if (cache) {
				try {
					const object = unpack(cache);
					if (typeof object === 'object') {
						Object.entries(object).forEach(([k, v]) => this.cache.set(k, v));
					}
				}
				catch {
					localStorage.removeItem('cache');
				}
			}
		}
		catch (error) {
			// TODO checks why there are errors?
			console.error(error);
		}
	}

	save() {
		const object = {};
		if (this.cache.size > 0) {
			this.cache.forEach((v, k) => {
				object[k] = v;
			});

			try {
				localStorage.setItem('cache', pack(object));
			}
			catch (error) {
				console.error(error);
			}
		}
	}

	set(key, value) {
		this.cache.set(md5(key), value);
	}

	// a condition qu'il n'y ai qu'un seul resultat pour le clef de cache.
	setById(id, response) {
		this.cache.forEach(v => {
			if (v.id === id) {
				v.response = response;
				v.flag = true;
			}
		});
	}

	unset(key) {
		return this.cache.delete(md5(key));
	}

	unsetById(id) {
		const entries = this.cache.entries();
		let idx = entries.length - 1;
		while (idx >= 0) {
			if (entries[1].id === id) {
				this.unset(entries[0]);
			}
			idx--;
		}
	}
}

const Cache = new CacheModel();

export default Cache;
